<div class="unauthorized-layout">
  <router-outlet></router-outlet>
</div>
